import React from "react";
import { contrastColor } from "contrast-color";

import connectProps from "fantastic/lib/connectProps";
import utils from "fantastic/lib/utils";

import Section from "./preview/Section";

const Preview = ({ sections, theme, mobile, landscape, app: { preview_mode, theme_mode } }) => {

  const checkContrast = (color, name = '') => {
    if(theme_mode === preview_mode || !color || color.match(/(url|trans)/gi)) return color;


    // const fgDarkColor = name && theme.style_attributes[name] ? theme.style_attributes[name] : '#000000';
    // const fgLightColor = name && theme.style_attributes[name] ? theme.style_attributes[name] : '#FFFFFF';

    return contrastColor({
      bgColor: color,
      defaultColor: color,
      // fgDarkColor,
      // fgLightColor
    })
  };

  const renderSection = section => {
    return <Section key={section.id} {...section}
                    mobile={mobile}
                    checkContrast={checkContrast}
                    preview={true}
                    preview_mode={preview_mode}
                    theme_mode={theme_mode}
      />;
  };

  // Ha-ha! The zoom property is not working in Firefox >:F
  const adaptive = theme.style_attributes["include-html-media-query-classes"];
  const tableStyles = {
    backgroundColor: checkContrast(theme.style_attributes["base-bg"]),
    backgroundImage: utils.url(theme.style_attributes["base-bg-image"]),
    backgroundRepeat: theme.style_attributes["base-bg-repeat"],
    backgroundPosition: theme.style_attributes["base-bg-position"],
    zoom: mobile && !adaptive ? (landscape ? 0.89 : 0.48) : "none"
  };

  const instantThemeStyles = (styles) => {

    const isContrast = styles['include-html-color-scheme-classes'] && theme_mode !== preview_mode

    const baseBg = isContrast ? styles['base-bg-contrast'] : contrastColor({ bgColor: styles['base-bg'], defaultColor: styles['base-bg'] });
    const baseFontColor = isContrast ? styles['base-font-color-contrast']  : contrastColor({ bgColor: styles['base-font-color'], defaultColor: styles['base-font-color'] });
    const baseBgImage = isContrast ? styles['base-bg-image-contrast'] : styles['base-bg-image'];
    const baseBgRepeat = isContrast ? styles['base-bg-repeat-contrast'] : styles['base-bg-repeat'];
    const baseBgPosition = isContrast ? styles['base-bg-position-contrast'] : styles['base-bg-position'];

    return `

      .ink table.mail {
        background-color: ${baseBg} !important;
        background-image: url(${baseBgImage}) !important;
        background-repeat: url(${baseBgRepeat}) !important;
        background-position: url(${baseBgPosition}) !important;
      }
      .ink .mce-content-body, .ink .mce-content-body > * { color: ${baseFontColor} !important  }
    `;
  }

  return (
    <>
      {theme_mode !== preview_mode && <style>{instantThemeStyles(theme.style_attributes)}</style>}
      <div className="ink">
        <table className="mail" style={tableStyles}>
          <tbody>
            <tr>
              <td className="center" align="center" valign="top">
                {sections.map(renderSection)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default connectProps("sections", "theme", "app")(Preview);
